import * as actionTypes from '../actions/actionTypes';

export default function (state = null, action) {
  switch (action.type) {
    case actionTypes.SUBMIT_ASSET_CLASS_SUCCESS:
      return action.assetClass;
    case actionTypes.FETCH_ASSET_CLASS_SUCCESS:
      return action.assetClass;
    default:
      return state;
  }
}
